import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ConfirmationService, MessageService, SortEvent } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-lista-de-pessoas-view',
  templateUrl: './lista-de-pessoas-view.component.html',
  styleUrls: ['./lista-de-pessoas-view.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class ListadePessoasViewComponent implements OnInit, OnDestroy {
  pessoaId = -1;
  @Input() IsFornecedor: boolean = false;
  @Input() IsCliente: boolean = false;

  // Objetos de traducao
  tabs = {
    lista_de_notas: '',
    lista_de_produtos: '',
    movimentacoes: ''
  };

  private langChangeSub!: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {}

  async ngOnInit() {
    this.loadTranslations();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
    });

    this.pessoaId = Number(this.route.snapshot.paramMap.get('id'));

    if (!this.pessoaId || this.pessoaId <= 0) {
      this.router.navigate(['/lista-de-pessoas']);
      return;
    }
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  private loadTranslations(): void {
    this.tabs = {
      lista_de_notas: this.translate.instant('shared.lista-de-pessoas-view.tabs.lista_de_notas'),
      lista_de_produtos: this.translate.instant('shared.lista-de-pessoas-view.tabs.lista_de_produtos'),
      movimentacoes: this.translate.instant('shared.lista-de-pessoas-view.tabs.movimentacoes')
    };
  }
}
